<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Penalty Summary</h5>
    </div>
<div id="mainContent" class="container">
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-5">
            <div class="row">
                <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
                <div class="col-sm-6">
                    <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear"
                    (change)="getClosingDate()">
                        <option value="">Select Year
                        </option>
                        <option *ngFor="let finance of financialList" [ngValue]="finance">{{finance.name}}</option>

                    </select>
                </div>
            </div>
        </div>

        <div class="col-sm-5">
          <div class="row">
              <label class="col-sm-4 col-form-label">Closing Date<span class="text-danger">*</span></label>
              <div class="col-sm-6">
                  <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedClosing">
                      <option value="">Select Date
                      </option>
                      <option *ngFor="let closing of closingDateList" [value]="closing.id">{{closing.closingDate}}
                      </option>

                  </select>

              </div>
          </div>
      </div>
      <div class="col-sm-2">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">View
            Report</button>
    </div>
  </div>
 </div>
 </div>
 <br>
 <div *ngIf="reportList!=null">
<div class="container" id="mainContent">
<app-penalty-summary [reportList]="reportList" [isMyReport]=true [closingDateId]="selectedClosing"></app-penalty-summary>
</div>
</div>
</div>